import {
  useMutation, UseMutationOptions, UseMutationResult,
} from 'react-query';
import { useTranslation } from 'react-i18next';
import { Dayjs } from 'dayjs';
import {
  appendQueryParamIfNotEmpty, downloadDiggerFile, formatDate,
} from '../../../constants/hookConstants';
import closableEnqueueSnackbar from '../../../components/closableEnqueueSnackbar/closableEnqueueSnackbar';
import { TypeOfMutationFunction } from '../../../interfaces/query/queryHook.type';

interface GetExportUsersParamsInterface{
  identifier: string,
  firstName: string,
  lastName: string,
  email: string,
  orderBy: string,
  sortBy: string,
  from: Dayjs | null,
  to: Dayjs | null,
  rows: number,
  page: number,
}

export const useGetExportUsersTable = (
  params: GetExportUsersParamsInterface,
) => {
  const { t } = useTranslation();

  const queryParams = new URLSearchParams();
  appendQueryParamIfNotEmpty(queryParams, 'firstName', params.firstName.trim());
  appendQueryParamIfNotEmpty(queryParams, 'lastName', params.lastName.trim());
  appendQueryParamIfNotEmpty(queryParams, 'email', params.email.trim());
  appendQueryParamIfNotEmpty(queryParams, 'from', formatDate(params.from));
  appendQueryParamIfNotEmpty(queryParams, 'to', formatDate(params.to));
  appendQueryParamIfNotEmpty(queryParams, 'sortBy', params.sortBy.trim());
  appendQueryParamIfNotEmpty(queryParams, 'orderBy', params.orderBy.trim());
  appendQueryParamIfNotEmpty(queryParams, 'rows', params.rows.toString());
  appendQueryParamIfNotEmpty(queryParams, 'page', params.page.toString());

  const mutationFunction: TypeOfMutationFunction = async (acceptHeader: string) => {
    const url = `users?${queryParams}`;
    await downloadDiggerFile(url, acceptHeader, t);
  };

  const options: UseMutationOptions<void, unknown, string> = {
    onError: () => {
      closableEnqueueSnackbar(t('somethingWentWrong'), 'error');
    },
  };

  const mutation: UseMutationResult<void, unknown, string> = useMutation(
    mutationFunction,
    options,
  );

  return mutation;
};
